import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ContactInfoComponent } from "./contact-info.component";
import { InfoItemComponent } from "./info-item/info-item.component";
import { InstagramIconComponent } from "./info-item/instagram-icon/instagram-icon.component";
import { LocalizationIconComponent } from "./info-item/localization-icon/localization-icon.component";
import { PhoneIconComponent } from "./info-item/phone-icon/phone-icon.component";
import { BottomCopyrightComponent } from "./bottom-copyright/bottom-copyright.component";
import { FalarVendedorButtonComponent } from "./falar-vendedor-button.component";
import { ListaServicosComponent } from "./lista-servicos.component";

@NgModule({
  declarations: [
    ContactInfoComponent,
    InfoItemComponent,
    InstagramIconComponent,
    LocalizationIconComponent,
    PhoneIconComponent,
    BottomCopyrightComponent,
    FalarVendedorButtonComponent,
    ListaServicosComponent,
  ],
  imports: [CommonModule],
  exports: [
    ContactInfoComponent,
    InfoItemComponent,
    BottomCopyrightComponent,
    FalarVendedorButtonComponent,
    ListaServicosComponent,
  ],
})
export class SharedComponentsModule {}
